import { lazy } from 'react';

const Users = lazy(() =>
  import('components/Accesos/Users/index').then(module => ({
    default: module.Users,
  }))
);

const Permissions = lazy(() =>
  import('components/Accesos/Permissions/index').then(module => ({
    default: module.Permissions,
  }))
);

const PasswordChange = lazy(() =>
  import('components/Accesos/PasswordChange/index').then(module => ({
    default: module.PasswordChange,
  }))
);

const routesAccesos = [
  {
    path: "/accesos-permissions",
    name: "Permisos",
    icon: "nc-icon nc-bank",
    component: <Permissions />,
    permissions: ['89_PERMISOS'],
    layout: "/app",
    visibility: true,
    subRoutes: [],
  },
  {
    path: "/accesos-usuarios",
    name: "Usuarios",
    icon: "nc-icon nc-bank",
    component: <Users />,
    permissions: ['90_USUARIOS'],
    layout: "/app",
    visibility: true,
    subRoutes: [],
  },
  {
    path: "/cambiar-clave",
    name: "Usuarios",
    icon: "nc-icon nc-bank",
    component: <PasswordChange />,
    permissions: [],
    layout: "/app",
    visibility: false,
    subRoutes: [],
  }
]

export {
  routesAccesos
}